import { WebCategory } from '../../../../../domain/model/category/WebCategory';
import { localStorage } from '../../../../../shared/localstorage';

/**
 * local storageのキー : 下記の通りにlocal storageに保存する
 * ${KEY}.${category} = 最後に表示したサブカテゴリ
 */
const KEY = 'YAHOO.JP.News.Top.newsFeedTab.PC';
const VERSION = 1;

/**
 * localstorageに保存するデータのinterface
 */
interface IFeedTabStorage {
  [category: string]: string;
}

const actionTypes = {
  CHANGE_TAB: 'newsFeedTab/CHANGE_TAB',
  REFLECT_LOCALSTORAGE: 'newsFeedTab/REFLECT_LOCALSTORAGE'
} as const;

export interface ISubCategory {
  id: string;
  name: string;
  isCurrent: boolean;
}

/**
 * タブ切り替え
 *
 * @param category
 * @param subCategoryId
 */
const changeTab = (category: string, subCategoryId: string) => {
  return {
    type: actionTypes.CHANGE_TAB,
    payload: {
      category,
      subCategoryId
    }
  };
};

/**
 * localstorageのデータ反映
 */
const reflectLocalStorage = {
  type: actionTypes.REFLECT_LOCALSTORAGE
};

export const actions = {
  changeTab,
  reflectLocalStorage
} as const;

type ReturnValueOrItself<T> = T extends (...args: infer _) => infer R ? R : T;

/**
 * Actionの型
 */
export type Action = ReturnValueOrItself<(typeof actions)[keyof typeof actions]>;

export interface INewsFeedTabState {
  subCategories: ISubCategory[];
  category?: WebCategory;
  tabStorage?: IFeedTabStorage;
  isReflectedStorage: boolean;
}

const initialState: INewsFeedTabState = {
  subCategories: [],
  isReflectedStorage: false
};

/**
 * subCategoriesのリストを更新する
 *
 * @param subCategories
 * @param currentSubCategory
 */
const updateSubCategories = (subCategories: ISubCategory[], currentSubCategory?: string): ISubCategory[] => {
  return subCategories.map((subCategory, index) => {
    return {
      ...subCategory,
      isCurrent: currentSubCategory ? subCategory.id === currentSubCategory : index === 0
    };
  });
};

export default (state: INewsFeedTabState = initialState, action: Action): INewsFeedTabState => {
  switch (action.type) {
    case actionTypes.CHANGE_TAB: {
      // インフィード広告インスタンスを初期化
      delete window.ytManager;

      const { category, subCategoryId } = action.payload;

      // storageに保存
      const storage: IFeedTabStorage = localStorage.get(KEY, VERSION) || {};
      storage[category] = subCategoryId;
      localStorage.set(KEY, VERSION, storage);

      return {
        ...state,
        subCategories: updateSubCategories(state.subCategories, subCategoryId),
        tabStorage: storage
      };
    }
    case actionTypes.REFLECT_LOCALSTORAGE: {
      // localstorageのデータを取得してstoreに反映
      const storage: IFeedTabStorage = localStorage.get(KEY, VERSION) || {};
      const currentSubCategory = storage[state.category || ''];

      return {
        ...state,
        isReflectedStorage: true,
        subCategories: updateSubCategories(state.subCategories, currentSubCategory),
        tabStorage: localStorage.get(KEY, VERSION)
      };
    }
  }
  return state;
};
